import { logError as sentryLogError } from './sentryUtils';

/**
 * Logs an error to available error handlers
 * @param {Error} error - The error object to log
 * @param {Object} [context=null] - Additional context information for the error
 * @example
 * const error = new Error('Something went wrong');
 * const context = { page: 'home', action: 'click' };
 * logError(error, context);
 */
function logError(error, context = null) {
    sentryLogError(error, context);
}

/**
 * Extracts a human-readable error message from various error formats
 *
 * @param {string|Error|Object} error - The error to parse
 * @returns {string} A human-readable error message
 *
 * @example
 * parseErrorMessage('Network timeout') // 'Network timeout'
 * parseErrorMessage(new Error('Invalid input')) // 'Invalid input'
 * parseErrorMessage({ error: { message: 'User not found' } }) // 'User not found'
 * parseErrorMessage({ toString: () => 'Custom error' }) // 'Custom error'
 * parseErrorMessage(null) // 'Unknown error'
 */
export const parseErrorMessage = (error) => {
    if (typeof error === 'string') return error;
    if (error?.error?.message) return error.error.message;
    if (error?.message) return error.message;
    if (error?.toString) return error.toString();
    return 'Unknown error';
};

export default logError;
